export enum HeaderFilterType {
  Order = 'Order',
  Filter = 'Filter',
  Sort = 'Sort',
  Time = 'Time',
}
